document.addEventListener('DOMContentLoaded', function () {

    const eyeContainer = document.querySelectorAll('.eye-container');

    if (eyeContainer.length) {
        eyeContainer.forEach((container) => {
            const irisCircle = container.querySelector('#irisCircle');
            const eyeSVG = container.querySelector('#eye');
            const eyeBg = container.querySelector('.eye-bg');
        
            if (irisCircle && eyeSVG && eyeBg) {
                // Center point of the eye (see SVG bounding box dimensions)
                const centerX = 66.72;
                const centerY = 32.48;
        
                // Maximum movement range from center (in SVG units)
                const maxMoveX = 10;
                const maxMoveY = 5;
        
        
                // ======== Iris mouse tracking ======== 
                document.addEventListener('mousemove', function (e) {
                    // Get SVG's position and dimensions:
                    const svgRect = eyeSVG.getBoundingClientRect();
        
                    // Calculate mouse position relative to the viewport center as a percentage (-1 to 1)
                    const windowWidth = window.innerWidth;
                    const windowHeight = window.innerHeight;
        
                    const mouseXPercent = (e.clientX / windowWidth) * 2 - 1;
                    const mouseYPercent = (e.clientY / windowHeight) * 2 - 1;
        
                    // Calculate new iris position with limited movement range
                    const newX = centerX + (mouseXPercent * maxMoveX);
                    const newY = centerY + (mouseYPercent * maxMoveY);
        
                    // Update the iris circle position attributes
                    irisCircle.setAttribute('cx', newX);
                    irisCircle.setAttribute('cy', newY);
                });
        
                // ======== Random blinking functionality ========
                function initBlinking() {
        
                    // Do initial blink
                    scheduleNextBlink();
        
                    function blink() {
        
                        // 150-200ms for the blink itself
                        const blinkDuration = 150 + Math.random() * 50;
        
                        // The animation keyframes
                        const keyframes = [
                            { transform: 'scaleY(100%)' },  // Start (open)
                            { transform: 'scaleY(5%)' },  // Middle (closed)
                            { transform: 'scaleY(100%)' }   // End (open)
                        ];
        
                        if (typeof eyeBg !== "undefined") {
                            // Make it blink!
                            eyeBg.animate(keyframes, {
                                duration: blinkDuration,
                                easing: 'ease-in-out',
                                iterations: 1,
                                fill: 'forwards'
                            });
        
                            // ... then schedule the next blink
                            scheduleNextBlink();
                        }
                    }
        
                    function scheduleNextBlink() {
                        let nextBlinkDelay;
        
                        // 10% chance of a rapid double or triple blink
                        if (Math.random() < 0.1) {
                            nextBlinkDelay = 300 + Math.random() * 200; // 300-500ms for rapid blinks
                        } else {
                            // Normal blink interval (2-7 seconds)
                            nextBlinkDelay = 2000 + Math.random() * 5000;
                        }
        
                        setTimeout(blink, nextBlinkDelay);
                    }
                };
        
                // Start blinking!
                initBlinking();
            }
        })
    }
});